import script from "./CompetenciesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetenciesCard.vue?vue&type=script&setup=true&lang=js"

import "./CompetenciesCard.vue?vue&type=style&index=0&id=ecab6aa2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecab6aa2"]])

export default __exports__